import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../../api/api";
import { Address_url, signup_url } from "../../api/urls";
import { useSelector } from "react-redux";
import NoImage from "../../Assests/blank_delete.png";
import { Order_summary } from "../../api/urls";

import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import { Pencil, Trash2, ChevronRight, Search } from "lucide-react";
import { setBillingId, setShippingId } from "../../Redux/CartSlice";
import { useDispatch } from "react-redux";
import PaymentPopupCheckout from "../CreateCheckoutFlow/PaymentPopupCheckout";
import Loading from "../../components/Loading";
import { toast } from "react-toastify";
import useFetch from "../../hooks/useFetch";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";

// import ProfileImage from "../profile/ProfileImage";

const AddressBook = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const currpath = location.pathname;
  // console.log(currpath, "currpath");
  const isCart = !currpath.includes("my_address");
  const dispatch = useDispatch();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const { defaultPincode } = useSelector((state) => state.auth);
  const [searchTerm, setSearchTerm] = useState("");
  // const [addresses, setAddresses] = useState([]);
  const [filteredAddresses, setFilteredAddresses] = useState([]);
  const [loader, setLoader] = useState(false);
  const { accessToken } = useSelector((state) => state.auth);
  // const user = useSelector((state) => state.auth.user);
  const { data: user } = useFetch(accessToken && signup_url);
  // console.log("location AddressBook:", location.state);
  // console.log("Profile Image URL:", user?.profile_image);
  const [openPopup, setOpenPopup] = useState(false);

  // const [paymentMethod, setPaymentMethod] = useState("");
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: addressData, refetch, loading } = useFetch(Address_url(""));
  const addresses = addressData?.response;
  const cart = useSelector((state) => state.cart);
  const buyNowPayload = useSelector((state) => state.cart.buyNowData);
  const skip = useSelector((state) => state.cart.skipPaymentPopup);
  // const [loading, setLoading] = useState(false);

  const totals = location.state?.totals || {};
  const isBuyNow = location.state?.isBuyNow || false;
  const consumedBy = location.state?.consumedBy;
  console.log(consumedBy, "i am the consumeby method");
  const quantityBuyNow = location.state?.quantity;

  const handleSubmit = useCallback(async () => {
    // const selectedMethod = autoMethod || paymentMethod;
    if (!consumedBy) {
      toast.error("Please select a payment method before proceeding!");
      return;
    }

    const shopPayload = {
      payment_method: consumedBy,
      shipping_id: cart.shipping_id,
      billing_id: cart.billing_id,
      company_name: cart.company_name,
      gstin_number: cart.gstin_number,
      pan_number: cart.pan_number,
      is_company: cart.is_company,
      amount: totals.finalTotal,
      points: cart.points,
      wallet: cart.wallet,
      credit: cart.credit,
    };
    try {
      setLoader(true);

      // 👇 added: check your payload before API call
      // console.log("🛒 Cart from Redux:", cart);
      // console.log("🧾 Shop payload:", shopPayload);
      // console.log("💳 Is Buy Now:", isBuyNow);
      // console.log("🪙 Consumed by:", consumedBy);

      const orderData = isBuyNow
        ? {
            hexcolor: buyNowPayload.selected_color || null,
            size_label: buyNowPayload.selected_size || null,
            quantity: quantityBuyNow,
            product: buyNowPayload.id,
            ...shopPayload,
          }
        : {
            cart: cart.cartIds
              ?.filter((id) => id != null)
              .map((id) => id.toString()),
            ...shopPayload,
          };

      // 👇 added: print final payload before sending to backend
      // console.log("📦 Final order payload being sent to backend:", orderData);

      const response = await api.post(Order_summary, orderData);

      // console.log("✅ Payment API response:", response?.data); // 👇 added

      // window.open(response?.data?.pay);
      // window.location.href = response?.data?.pay;

      // navigate("/your_order");
      //  Redirect only to payment
      window.location.href = response?.data?.pay;
    } catch (error) {
      // 👇 added: log full error info
      console.error(" Payment error full object:", error);
      console.error(" Backend error response:", error.response?.data);

      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.pay ||
          error.message ||
          "Something went wrong",
      );
    } finally {
      // setIsSubmitting(false);
      // setLoading(false);
      //  setLoader(false)
    }
  }, [consumedBy, cart, totals.finalTotal, isBuyNow, buyNowPayload, quantityBuyNow]);

  useEffect(() => {
    const paymentOptions = location.state?.paymentOptions || {};
    const creditBalance = location.state?.credit?.balance || 0;
    const totalToPay = location.state?.totals?.finalTotal || 0;

    const creditFullyCovers =
      paymentOptions?.credit && creditBalance >= totalToPay;

    if (skip && creditFullyCovers) {
      handleSubmit("Credits");
    }
  }, [skip, location.state, handleSubmit]);

  useEffect(() => {
    // normalize once
    const lower = searchTerm.trim().toLowerCase();

    let filtered;

    if (isCart) {
      // Cart mode: only filter by pincode
      filtered = addresses?.filter(
        (item) => item.pincode === String(defaultPincode),
      );
    } else if (lower === "") {
      // Non-cart mode + empty search: return all addresses
      filtered = addresses;
    } else {
      // Non-cart mode + search term: filter by pincode + search
      filtered = addresses?.filter(
        (item) =>
          item.pincode === String(defaultPincode) &&
          (item.name?.toLowerCase().includes(lower) ||
            item.address?.toLowerCase().includes(lower) ||
            item.state_name?.toLowerCase().includes(lower) ||
            item.primary_mobile?.includes(searchTerm)), // keep raw for numbers
      );
    }

    setFilteredAddresses(filtered);
  }, [searchTerm, addresses, defaultPincode, isCart]);

  // useEffect(() => {
  //   const fetchAddresses = async () => {
  //     try {
  //       const response = await api.get(Address_url(""));
  //       const addressList = Array.isArray(response.data?.response)
  //         ? response.data.response
  //         : [];

  //       setAddresses(addressList);
  //       setFilteredAddresses(addressList);
  //     } catch (err) {
  //       console.error("Failed to fetch addresses", err);
  //     }
  //   };

  //   fetchAddresses();
  // }, []);
  const handleAddNewAddress = () => {
    navigate("/address");
  };

  const handleEditAddress = (address) => {
    navigate("/address", { state: { editAddress: address } });
  };

  const handleDeleteAddress = async (addressId) => {
    try {
      await api.delete(Address_url(addressId));
      refetch();
      // const updated = addresses.filter((addr) => addr.id !== addressId);
      // setAddresses(updated);

      // setFilteredAddresses(updated);
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error("Failed to delete address.");
    }
  };

  // const handleSelectAddress = (address) => {
  //   if (currpath === "/shipping_address") {
  //     dispatch(setShippingId(address.id));
  //     navigate("/billing_address", {
  //       state: { selectedAddress: address, ...location.state },
  //     });
  //   } else if (currpath === "/billing_address" && !loader) {
  //     dispatch(setBillingId(address.id));
  //     if (location.state.amountToPay === 0) {
  //       handleSubmit();
  //     } else {
  //       setOpenPopup(true);
  //     }
  //   }
  // };

  const handleSelectAddress = (address) => {
    setLoader(true); // start skeleton

    setTimeout(() => {
      if (currpath === "/shipping_address") {
        dispatch(setShippingId(address.id));
        navigate("/billing_address", {
          state: { selectedAddress: address, ...location.state },
        });
      } else if (currpath === "/billing_address") {
        dispatch(setBillingId(address.id));

        if (location.state.amountToPay === 0) {
          handleSubmit();
        } else {
          setOpenPopup(true);
        }
      }

      setLoader(false); // stop skeleton after navigation/action
    }, 1000); // ⏳ 1 second delay
  };
  const handletitle = () => {
    if (currpath === "/shipping_address") {
      return "SELECT SHIPPING ADDRESS";
    } else if (currpath === "/billing_address") {
      return "SELECT BILLING ADDRESS ";
    } else {
      return;
    }
  };

  // if (loading) return <loading />;
  if (loading) return <Loading />;
  return (
    <Box
      sx={{
        px: { xs: 2, sm: 4 },
        py: { xs: 2, sm: 4 },
        minHeight: "100vh",
        backgroundColor: "#f8f8f8",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: "1000px" }}>
        <Box display="flex" alignItems="center" mb={3}>
          <Box
            component="img"
            src={user?.profile_image || NoImage}
            alt="Profile"
            sx={{
              width: {
                xs: 40,
                sm: 50,
                md: 60,
                lg: 70,
              },
              height: {
                xs: 40,
                sm: 50,
                md: 60,
                lg: 70,
              },
              borderRadius: "50%",
              objectFit: "cover",
              mr: 2,
            }}
          />

          <Box>
            <Typography fontWeight={500} fontSize="19px">
              {user?.full_name}
            </Typography>
            {/* <Typography fontSize="14px" color="#666">
              {user?.birthday || "DOB not set"}
            </Typography>  i have commnted dov here*/}
          </Box>
        </Box>

        <Typography variant="h6" sx={{ mb: 2 }}>
          {handletitle()}
        </Typography>

        {/* Add New Address */}
        <Paper
          elevation={0}
          onClick={handleAddNewAddress}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            mb: 3,
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            cursor: "pointer",
            maxWidth: "490px",
            "&:hover": { backgroundColor: "#f9f9f9" },
          }}
        >
          <Typography fontWeight={500}>Add New Address </Typography>
          <ChevronRight size={20} />
        </Paper>

        {/* Search Field */}
        <TextField
          fullWidth
          placeholder="Search addresses"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search size={18} />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 4, maxWidth: "490px" }}
        />

        {/* Address List */}
        <Grid container spacing={2}>
          {loader &&
            Array.from({ length: filteredAddresses?.length || 1 }).map(
              (_, i) => <SkeletonAddressCard key={i} />,
            )}
          {!loader && (
            <>
              {filteredAddresses && filteredAddresses.length > 0 ? (
                filteredAddresses?.map((address) => (
                  <Grid item xs={12} sm={6} key={address.id}>
                    <Paper
                      elevation={0}
                      onClick={() => handleSelectAddress(address)}
                      sx={{
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        cursor: "pointer",
                        minHeight: "150px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        "&:hover": { backgroundColor: "#f9f9f9" },
                      }}
                    >
                      <Box display="flex" justifyContent="space-between">
                        <Typography fontWeight={600}>{address.name}</Typography>
                        <Box>
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditAddress(address);
                            }}
                          >
                            <Pencil size={16} />
                          </IconButton>
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              // handleDeleteAddress(address.id);
                              setSelectedDeleteId(address.id);
                              setOpenDeleteDialog(true);
                            }}
                          >
                            <Trash2 size={16} color="red" />
                          </IconButton>
                        </Box>
                      </Box>
                      <Box>
                        <Typography variant="body2">
                          {address.address}, {address.address_two},{" "}
                          {address.landmark}, {address.city},{" "}
                          {address.state_name}
                        </Typography>
                        <Typography variant="body2">
                          Pincode: {address.pincode}
                        </Typography>
                        <Typography variant="body2">
                          Phone: {address.primary_mobile}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                ))
              ) : (
                // <Typography >No addresses founddddd</Typography>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      ml: { xs: 0, sm: 0 }, // adjust left margin if needed
                      mt: 2,
                    }}
                  >
                    {isCart
                      ? `No addresses found matching pincode ${defaultPincode}`
                      : "No addresses found"}
                  </Typography>
                </Grid>
              )}
            </>
          )}
        </Grid>
        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
          PaperProps={{
            sx: {
              borderRadius: "12px", // popup border radius
            },
          }}
        >
          <DialogContent>
            <Typography fontSize={15} fontWeight={600}>
              Are you sure you want to delete the address?
            </Typography>
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button
              variant="outlined"
              onClick={() => setOpenDeleteDialog(false)}
              sx={{
                borderColor: "#ccc",
                color: "#000",
                width: "100px",
                textTransform: "none",
                flex: 1,
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                handleDeleteAddress(selectedDeleteId);
                setOpenDeleteDialog(false);
              }}
              sx={{
                backgroundColor: "#c62626",
                "&:hover": { backgroundColor: "#c62626" },
                width: "100px",
                textTransform: "none",
                flex: 1,
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      <PaymentPopupCheckout
        // onClose={onClose}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        // skip={skipPayment}
      />
    </Box>
  );
};

export default AddressBook;

const SkeletonAddressCard = () => {
  return (
    <Grid item xs={12} sm={6}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          minHeight: "150px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* Top Row: Name + Icons */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Skeleton variant="text" width="40%" height={24} /> {/* Name */}
          <Box display="flex" gap={1}>
            <Skeleton variant="circular" width={28} height={28} />
            <Skeleton variant="circular" width={28} height={28} />
          </Box>
        </Box>

        {/* Address Lines */}
        <Box mt={1}>
          <Skeleton variant="text" width="100%" height={18} />
          <Skeleton variant="text" width="90%" height={18} />
          <Skeleton variant="text" width="50%" height={18} />
        </Box>
      </Paper>
    </Grid>
  );
};
